import { render, staticRenderFns } from "./trafficOpen.vue?vue&type=template&id=02cd7968&scoped=true&"
import script from "./trafficOpen.vue?vue&type=script&lang=js&"
export * from "./trafficOpen.vue?vue&type=script&lang=js&"
import style0 from "./trafficOpen.vue?vue&type=style&index=0&id=02cd7968&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cd7968",
  null
  
)

export default component.exports